// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FooterPgae_wrapper {
  width: 100%;
  background: #ffffff;
  overflow: hidden;
}

.FooterPgae_scene {
  position: relative;
  min-height: 320px;
  overflow: hidden;
}

/* ---------- Hills ---------- */

.FooterPgae_hill {
  position: absolute;
  bottom: -160px;
  width: 340px;
  height: 340px;
  border-radius: 50%;
  background: #852490;
  opacity: 0;
  animation: FooterPgae_riseIn 0.8s ease forwards;
}

.FooterPgae_hill--left {
  left: -140px;
  animation-delay: 0.1s;
}

.FooterPgae_hill--right {
  right: -140px;
  animation-delay: 0.25s;
}

/* ---------- Buildings ---------- */

.FooterPgae_building {
  position: absolute;
  background: #f1edee;
  border-radius: 2px 2px 0 0;
  opacity: 0;
  animation: FooterPgae_fadeUp 0.5s ease forwards;
}

.FooterPgae_building--1 {
  width: 26px;
  height: 60px;
  bottom: 150px;
  left: 60px;
  animation-delay: 0.5s;
}

.FooterPgae_building--2 {
  width: 34px;
  height: 82px;
  bottom: 150px;
  left: 92px;
  animation-delay: 0.6s;
}

.FooterPgae_building--3 {
  width: 30px;
  height: 70px;
  bottom: 150px;
  right: 70px;
  animation-delay: 0.55s;
}

.FooterPgae_building--4 {
  width: 22px;
  height: 96px;
  bottom: 150px;
  right: 106px;
  animation-delay: 0.65s;
}

/* ---------- Trees ---------- */

.FooterPgae_tree {
  position: absolute;
  width: 16px;
  height: 22px;
  background: #f1edee;
  border-radius: 50% 50% 4px 4px;
  opacity: 0;
  animation: FooterPgae_fadeUp 0.5s ease forwards;
}

.FooterPgae_tree--3 {
  bottom: 148px;
  right: 40px;
  animation-delay: 0.7s;
}

/* ---------- Windmills ---------- */

.FooterPgae_windmill {
  position: absolute;
  bottom: 150px;
  width: 3px;
  height: 90px;
  background: #fffcfd;
  opacity: 0;
  animation: FooterPgae_fadeUp 0.5s ease forwards;
}

.FooterPgae_windmill--1 {
  right: 150px;
  animation-delay: 0.4s;
}

.FooterPgae_windmill--2 {
  right: 180px;
  height: 70px;
  animation-delay: 0.45s;
}

.FooterPgae_blades {
  position: absolute;
  top: -10px;
  left: -9px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background:
    linear-gradient(#ffffff, #ffffff) center/3px 20px no-repeat,
    linear-gradient(#ffffff, #ffffff) center/20px 3px no-repeat;
  animation: FooterPgae_spin 2.4s linear infinite;
}

/* ---------- Clouds ---------- */

.FooterPgae_cloud {
  position: absolute;
  width: 46px;
  height: 16px;
  background: #f7c9cd;
  border-radius: 20px;
  opacity: 0.9;
}

.FooterPgae_cloud--1 {
  top: 40px;
  left: 12%;
  animation: FooterPgae_drift 14s linear infinite;
}

.FooterPgae_cloud--2 {
  top: 70px;
  right: 20%;
  width: 34px;
  animation: FooterPgae_drift 18s linear infinite reverse;
}

.FooterPgae_cloud--3 {
  top: 100px;
  left: 30%;
  width: 30px;
  animation: FooterPgae_drift 20s linear infinite;
}

/* ---------- Center content ---------- */

.FooterPgae_content {
  position: relative;
  z-index: 6;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 220px;
  padding: 20px 20px;
  opacity: 0;
  animation: FooterPgae_fadeUp 0.7s ease forwards 0.5s;
}

.FooterPgae_logo {
  height: 175px;
  width: auto;
  margin-bottom: 18px;
  transition: transform 0.3s ease;
}

.FooterPgae_logo:hover {
  transform: scale(1.06);
}

.FooterPgae_address {
  max-width: 420px;
  color: #4a4a4a;
  font-size: 15.5px;
  line-height: 1.7;
  margin: 0;
}

/* ---------- Bottom bar ---------- */

.FooterPgae_bottomBar {
  background: #852490;
  padding: 16px 24px;
  text-align: center;
}

.FooterPgae_copyright {
  color: #b7b9bf;
  font-size: 12px;
}

/* ---------- Keyframes ---------- */

@keyframes FooterPgae_riseIn {
  to {
    opacity: 1;
  }
}

@keyframes FooterPgae_fadeUp {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes FooterPgae_spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes FooterPgae_drift {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(40px);
  }
}

/* ---------- Responsive ---------- */

@media (max-width: 900px) {
  .FooterPgae_hill {
    display: none;
  }

  .FooterPgae_scene,
  .FooterPgae_content {
    min-height: 200px;
  }
}

@media (max-width: 600px) {
  .FooterPgae_hill--left {
    left: -180px;
  }

  .FooterPgae_hill--right {
    right: -180px;
  }

  .FooterPgae_scene,
  .FooterPgae_content {
    min-height: 240px;
  }

  .FooterPgae_logo {
    height: 90px;
  }

  .FooterPgae_address {
    font-size: 12.5px;
    max-width: 300px;
  }
}

/* ---------- Small phones (~360px) ---------- */

@media (max-width: 400px) {
  .FooterPgae_hill {
    width: 220px;
    height: 180px;
    bottom: -90px;
  }

  .FooterPgae_hill--left {
    left: -110px;
  }

  .FooterPgae_hill--right {
    right: -110px;
  }

  .FooterPgae_building,
  .FooterPgae_tree,
  .FooterPgae_windmill {
    transform: scale(0.75);
  }

  .FooterPgae_building--1,
  .FooterPgae_tree--3 {
    bottom: 100px;
  }

  .FooterPgae_building--2 {
    bottom: 100px;
  }

  .FooterPgae_building--3,
  .FooterPgae_building--4 {
    bottom: 100px;
  }

  .FooterPgae_windmill--1,
  .FooterPgae_windmill--2 {
    bottom: 100px;
  }

  .FooterPgae_scene,
  .FooterPgae_content {
    min-height: 200px;
  }

  .FooterPgae_content {
    padding: 16px 12px;
  }

  .FooterPgae_logo {
    height: 64px;
    margin-bottom: 10px;
  }

  .FooterPgae_address {
    font-size: 11.5px;
    line-height: 1.6;
    max-width: 260px;
  }

  .FooterPgae_bottomBar {
    padding: 12px 16px;
  }

  .FooterPgae_copyright {
    font-size: 11px;
  }
}`, "",{"version":3,"sources":["webpack://./src/HeadFoot/FooterPage/FooterPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,gCAAgC;;AAEhC;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,oCAAoC;;AAEpC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;AAEA,gCAAgC;;AAEhC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA,oCAAoC;;AAEpC;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB;;+DAE6D;EAC7D,+CAA+C;AACjD;;AAEA,iCAAiC;;AAEjC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,SAAS;EACT,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,uDAAuD;AACzD;;AAEA;EACE,UAAU;EACV,SAAS;EACT,WAAW;EACX,+CAA+C;AACjD;;AAEA,yCAAyC;;AAEzC;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA,qCAAqC;;AAErC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,oCAAoC;;AAEpC;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,qCAAqC;;AAErC;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA,gDAAgD;;AAEhD;EACE;IACE,YAAY;IACZ,aAAa;IACb,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,sBAAsB;EACxB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".FooterPgae_wrapper {\n  width: 100%;\n  background: #ffffff;\n  overflow: hidden;\n}\n\n.FooterPgae_scene {\n  position: relative;\n  min-height: 320px;\n  overflow: hidden;\n}\n\n/* ---------- Hills ---------- */\n\n.FooterPgae_hill {\n  position: absolute;\n  bottom: -160px;\n  width: 340px;\n  height: 340px;\n  border-radius: 50%;\n  background: #852490;\n  opacity: 0;\n  animation: FooterPgae_riseIn 0.8s ease forwards;\n}\n\n.FooterPgae_hill--left {\n  left: -140px;\n  animation-delay: 0.1s;\n}\n\n.FooterPgae_hill--right {\n  right: -140px;\n  animation-delay: 0.25s;\n}\n\n/* ---------- Buildings ---------- */\n\n.FooterPgae_building {\n  position: absolute;\n  background: #f1edee;\n  border-radius: 2px 2px 0 0;\n  opacity: 0;\n  animation: FooterPgae_fadeUp 0.5s ease forwards;\n}\n\n.FooterPgae_building--1 {\n  width: 26px;\n  height: 60px;\n  bottom: 150px;\n  left: 60px;\n  animation-delay: 0.5s;\n}\n\n.FooterPgae_building--2 {\n  width: 34px;\n  height: 82px;\n  bottom: 150px;\n  left: 92px;\n  animation-delay: 0.6s;\n}\n\n.FooterPgae_building--3 {\n  width: 30px;\n  height: 70px;\n  bottom: 150px;\n  right: 70px;\n  animation-delay: 0.55s;\n}\n\n.FooterPgae_building--4 {\n  width: 22px;\n  height: 96px;\n  bottom: 150px;\n  right: 106px;\n  animation-delay: 0.65s;\n}\n\n/* ---------- Trees ---------- */\n\n.FooterPgae_tree {\n  position: absolute;\n  width: 16px;\n  height: 22px;\n  background: #f1edee;\n  border-radius: 50% 50% 4px 4px;\n  opacity: 0;\n  animation: FooterPgae_fadeUp 0.5s ease forwards;\n}\n\n.FooterPgae_tree--3 {\n  bottom: 148px;\n  right: 40px;\n  animation-delay: 0.7s;\n}\n\n/* ---------- Windmills ---------- */\n\n.FooterPgae_windmill {\n  position: absolute;\n  bottom: 150px;\n  width: 3px;\n  height: 90px;\n  background: #fffcfd;\n  opacity: 0;\n  animation: FooterPgae_fadeUp 0.5s ease forwards;\n}\n\n.FooterPgae_windmill--1 {\n  right: 150px;\n  animation-delay: 0.4s;\n}\n\n.FooterPgae_windmill--2 {\n  right: 180px;\n  height: 70px;\n  animation-delay: 0.45s;\n}\n\n.FooterPgae_blades {\n  position: absolute;\n  top: -10px;\n  left: -9px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background:\n    linear-gradient(#ffffff, #ffffff) center/3px 20px no-repeat,\n    linear-gradient(#ffffff, #ffffff) center/20px 3px no-repeat;\n  animation: FooterPgae_spin 2.4s linear infinite;\n}\n\n/* ---------- Clouds ---------- */\n\n.FooterPgae_cloud {\n  position: absolute;\n  width: 46px;\n  height: 16px;\n  background: #f7c9cd;\n  border-radius: 20px;\n  opacity: 0.9;\n}\n\n.FooterPgae_cloud--1 {\n  top: 40px;\n  left: 12%;\n  animation: FooterPgae_drift 14s linear infinite;\n}\n\n.FooterPgae_cloud--2 {\n  top: 70px;\n  right: 20%;\n  width: 34px;\n  animation: FooterPgae_drift 18s linear infinite reverse;\n}\n\n.FooterPgae_cloud--3 {\n  top: 100px;\n  left: 30%;\n  width: 30px;\n  animation: FooterPgae_drift 20s linear infinite;\n}\n\n/* ---------- Center content ---------- */\n\n.FooterPgae_content {\n  position: relative;\n  z-index: 6;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  min-height: 220px;\n  padding: 20px 20px;\n  opacity: 0;\n  animation: FooterPgae_fadeUp 0.7s ease forwards 0.5s;\n}\n\n.FooterPgae_logo {\n  height: 175px;\n  width: auto;\n  margin-bottom: 18px;\n  transition: transform 0.3s ease;\n}\n\n.FooterPgae_logo:hover {\n  transform: scale(1.06);\n}\n\n.FooterPgae_address {\n  max-width: 420px;\n  color: #4a4a4a;\n  font-size: 15.5px;\n  line-height: 1.7;\n  margin: 0;\n}\n\n/* ---------- Bottom bar ---------- */\n\n.FooterPgae_bottomBar {\n  background: #852490;\n  padding: 16px 24px;\n  text-align: center;\n}\n\n.FooterPgae_copyright {\n  color: #b7b9bf;\n  font-size: 12px;\n}\n\n/* ---------- Keyframes ---------- */\n\n@keyframes FooterPgae_riseIn {\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes FooterPgae_fadeUp {\n  from {\n    opacity: 0;\n    transform: translateY(14px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes FooterPgae_spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes FooterPgae_drift {\n  from {\n    transform: translateX(0);\n  }\n  to {\n    transform: translateX(40px);\n  }\n}\n\n/* ---------- Responsive ---------- */\n\n@media (max-width: 900px) {\n  .FooterPgae_hill {\n    display: none;\n  }\n\n  .FooterPgae_scene,\n  .FooterPgae_content {\n    min-height: 200px;\n  }\n}\n\n@media (max-width: 600px) {\n  .FooterPgae_hill--left {\n    left: -180px;\n  }\n\n  .FooterPgae_hill--right {\n    right: -180px;\n  }\n\n  .FooterPgae_scene,\n  .FooterPgae_content {\n    min-height: 240px;\n  }\n\n  .FooterPgae_logo {\n    height: 90px;\n  }\n\n  .FooterPgae_address {\n    font-size: 12.5px;\n    max-width: 300px;\n  }\n}\n\n/* ---------- Small phones (~360px) ---------- */\n\n@media (max-width: 400px) {\n  .FooterPgae_hill {\n    width: 220px;\n    height: 180px;\n    bottom: -90px;\n  }\n\n  .FooterPgae_hill--left {\n    left: -110px;\n  }\n\n  .FooterPgae_hill--right {\n    right: -110px;\n  }\n\n  .FooterPgae_building,\n  .FooterPgae_tree,\n  .FooterPgae_windmill {\n    transform: scale(0.75);\n  }\n\n  .FooterPgae_building--1,\n  .FooterPgae_tree--3 {\n    bottom: 100px;\n  }\n\n  .FooterPgae_building--2 {\n    bottom: 100px;\n  }\n\n  .FooterPgae_building--3,\n  .FooterPgae_building--4 {\n    bottom: 100px;\n  }\n\n  .FooterPgae_windmill--1,\n  .FooterPgae_windmill--2 {\n    bottom: 100px;\n  }\n\n  .FooterPgae_scene,\n  .FooterPgae_content {\n    min-height: 200px;\n  }\n\n  .FooterPgae_content {\n    padding: 16px 12px;\n  }\n\n  .FooterPgae_logo {\n    height: 64px;\n    margin-bottom: 10px;\n  }\n\n  .FooterPgae_address {\n    font-size: 11.5px;\n    line-height: 1.6;\n    max-width: 260px;\n  }\n\n  .FooterPgae_bottomBar {\n    padding: 12px 16px;\n  }\n\n  .FooterPgae_copyright {\n    font-size: 11px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
